import { useState, useEffect } from "react";
import { OrderTransport } from "src/app/transports/order";
import { Frequency, TFrequency } from "src/app/types/CreateOrders";
import { TLangType } from "src/app/types/LangType";
import { INetlinkingOrderInfo } from "src/app/types/orders/order";

const useGetNetlinkingOrderInfo = (
    keyword?: string,
    semRushKeywords?: string[],
    numberOfKeywords?: number,
    frequency?: Frequency,
    moneySiteId?: number,
    lang?: TLangType,
    initialRequest = true
) => {
    const [anchor, setAnchor] = useState<string[]>();
    const [netlinkingOrderInfo, setNetlinkingOrderInfo] = useState<INetlinkingOrderInfo[]>();
    const [price, setPrice] = useState<string | undefined>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | undefined>();

    const fetch = (
        fKeyword?: string,
        fSemRushKeywords?: string[],
        fNumberOfKeywords?: number,
        fFrequency?: TFrequency,
        fMoneySiteId?: number,
        fLang?: TLangType,
        setNetlinkingOrderInfoToData?: (netlinkingOrderInfo: INetlinkingOrderInfo[]) => void
    ) => {
        if (
            !fKeyword ||
            !fNumberOfKeywords ||
            !fSemRushKeywords ||
            !fFrequency ||
            !fLang ||
            !fMoneySiteId
        )
            return;
        setLoading(true);
        OrderTransport.getNetlinkingInformation({
            keyword: fKeyword,
            semRushKeywords: fSemRushKeywords,
            numberOfKeywords: fNumberOfKeywords,
            frequency: fFrequency,
            moneySiteId: fMoneySiteId,
            lang: fLang,
        })
            .then((res) => {
                setAnchor(res.anchor);
                setNetlinkingOrderInfo(res.netlinkingOrderInfo);
                setNetlinkingOrderInfoToData &&
                    setNetlinkingOrderInfoToData(res.netlinkingOrderInfo);
                setPrice(res.price);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (
        rKeyword?: string,
        rSemRushKeywords?: string[],
        rNumberOfKeywords?: number,
        rFrequency?: Frequency,
        rMoneySiteId?: number,
        rLang?: TLangType,
        setNetlinkingOrderInfoToData?: (netlinkingOrderInfo: INetlinkingOrderInfo[]) => void
    ) => {
        if (!loading)
            fetch(
                rKeyword,
                rSemRushKeywords,
                rNumberOfKeywords,
                rFrequency,
                rMoneySiteId,
                rLang,
                setNetlinkingOrderInfoToData
            );
    };

    useEffect(() => {
        if (initialRequest)
            fetch(keyword, semRushKeywords, numberOfKeywords, frequency, moneySiteId, lang);
    }, []);

    return { anchor, netlinkingOrderInfo, price, refresh, error, loading };
};

export default useGetNetlinkingOrderInfo;
